















































helpers = require('../../helpers.coffee')

view_model = {
  props:
    contact_group:
      type: ContactGroup

    view_mode:
      type: Object
      required: true

    selected_contact_ids:
      default: []

    initially_selected:
      default: false

  data: ->
    selected: false


  computed:
    # checks if all contacts of the group are selected
    all_group_contacts_selected: ->
      @checkAllContactsSelected()

    opportunities: ->
      value = @contact_group.opportunities_percentage
      if value == null then '--' else value + '%'

    group_contact_ids: ->
      @contact_group.contacts.map (contact) -> contact.id

    remove_label: ->
      if @view_mode.remove_action == "remove-from-flow" then @$t('contacts.actions.removeFromFlow') else @$t('general.actions.delete')

    import_action_label: ->
      if @contact_group.import_action == "updated" then @$t('contacts.actions.add') else @$t('groups.actions.create.createGroup')

    is_processing: ->
      @contact_group.isProcessing()

    is_with_error: ->
      @contact_group.isWithError()

    contact_group_status_message: ->
      if @contact_group.isProcessing()
        @$t('contacts_groups.feedback.updatingGroup')
      else if @contact_group.isWithError()
        @$t('contacts_groups.feedback.creationFail')

    contact_group_status_message_class: ->
      if @contact_group.isProcessing()
        'flow-message-status flow-processing-status'
      else if @contact_group.isWithError()
        'flow-message-status flow-error-status'

  methods:
    toggleSelected: ->
      @selected = !@selected
      @emitSelectionToggleEvent()

    emitSelectionToggleEvent: ->
      event.originalEventName = 'group-selected'
      attr = { @contact_group, @selected }
      @$emit 'group-selected', { event, attr }

    destroyGroup: (event, attr = {}) ->
      event.originalEventName = 'group-destroy'
      @$emit 'group-destroy', { event, @contact_group }

    selectedAll: (data) ->
      @selected = data.selected_all
      @emitSelectionToggleEvent()

    checkAllContactsSelected: ->
      self = this
      return false if @group_contact_ids == null || @group_contact_ids.length == 0
      @group_contact_ids.every (id) ->  self.selected_contact_ids.indexOf(id) >= 0

    editGroup: ->
      editGroupPath = "/grupos-de-contatos/#{@contact_group.id}/editar"
      @$router.push path: editGroupPath

    checkboxToggle: ->
      return if @view_mode.anywhere_select
      toggleSelected()

    rowClicked: (event) ->
      unless jQuery(event.target).closest('.clickable-element').length
        if @view_mode.anywhere_select then @toggleSelected() else @editGroup()

  created: ->
    @selected = @initially_selected || @checkAllContactsSelected()
    EventsBus.$on 'ContactGroupList:SelectedAll', @selectedAll

  beforeDestroy: ->
    EventsBus.$off 'ContactGroupList:SelectedAll', @selectedAll

  mounted: ->
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contact_groups/list_item.vue